module.exports = __webpack_public_path__ + "static/img/icon_logo_260318.7f1562d.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_logo_260318.png
// module id = sQt1
// module chunks = 1 5